/* Pixel da Meta: eventos padrão do site (ver snippets/meta-pixel.liquid e docs/PIXEL-META.md).
   content_ids = ID da variante Shopify, que é o ID do item no catálogo da Meta (app Facebook & Instagram).
   Todos passam por window.bellaFbq, que só envia depois do consentimento. */
(function () {
  var P = window.BellaPixel; if (!P || !P.eventos || typeof window.bellaFbq !== 'function') return;
  var moeda = P.moeda || 'BRL', pg = P.page || {};
  function origem(el) { var s = el && el.closest ? el.closest('.shopify-section') : null; return s ? s.id.replace('shopify-section-', '').split('__').pop() : 'flutuante'; }

  /* eventos de página */
  if (pg.tipo === 'product' && pg.produto) {
    var mc = new URLSearchParams(location.search).get('mc'); /* veio da loja da Meta: ID do item no catálogo é o da cópia 1 unidade */
    window.bellaFbq('track', 'ViewContent', { content_ids: [String(mc || pg.produto.variante || pg.produto.id)], content_type: 'product', content_name: pg.produto.nome, content_category: pg.produto.categoria, value: pg.produto.preco, currency: moeda });
  } else if (pg.tipo === 'collection' && pg.colecao) {
    window.bellaFbq('trackCustom', 'ViewCategory', { content_category: pg.colecao.nome, content_type: 'product_group', num_items: pg.colecao.itens });
  } else if (pg.tipo === 'search' && pg.busca) {
    window.bellaFbq('track', 'Search', { search_string: pg.busca.termo, num_items: pg.busca.resultados });
  } else if (pg.tipo === 'cart' && pg.carrinho) {
    window.bellaFbq('trackCustom', 'ViewCart', { value: pg.carrinho.valor, currency: moeda, num_items: pg.carrinho.itens, content_ids: (pg.carrinho.ids || []).map(String), content_type: 'product' });
  }

  /* adicionar ao carrinho (disparado por assets/carrinho.js) */
  document.addEventListener('bella:add', function (e) {
    var it = e.detail || {}; var qtd = it.quantity || 1, preco = (it.final_price || it.price || 0) / 100;
    window.bellaFbq('track', 'AddToCart', { content_ids: [String(it.variant_id || it.id)], content_type: 'product', content_name: it.product_title || it.title, value: Math.round(preco * qtd * 100) / 100, currency: moeda, num_items: qtd });
  });

  /* início do checkout (drawer e página do carrinho) */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-cd-checkout], button[name="checkout"]'); if (!a) return;
    var dados = { currency: moeda, content_type: 'product' };
    if (pg.carrinho) { dados.value = pg.carrinho.valor; dados.num_items = pg.carrinho.itens; dados.content_ids = (pg.carrinho.ids || []).map(String); }
    window.bellaFbq('track', 'InitiateCheckout', dados);
  }, true);

  /* WhatsApp: Contact quando a pessoa realmente vai para a conversa, com a unidade.
     Além do Contact (padrão da Meta), sai um evento personalizado por unidade
     ("wpp_aparecida", "wpp_paranaiba", "wpp_chapadao", os mesmos nomes do GA4) para contar cliques por cidade. */
  var ultimaOrigem = 'flutuante';
  function unidadePorNumero(href) {
    var m = (href || '').match(/wa\.me\/(\d+)/); if (!m) return '';
    var item = document.querySelector('a[data-wa-number="' + m[1] + '"]');
    return item ? (item.getAttribute('data-wa-unit') || '') : '';
  }
  function nomeEvento(unidade) { var s = (unidade || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().split(/\s+/)[0].replace(/[^a-z0-9]/g, ''); return 'wpp_' + (s || 'unidade'); }
  function contato(unidade, de) {
    window.bellaFbq('track', 'Contact', { content_name: 'whatsapp', content_category: de, unidade: unidade || '' });
    window.bellaFbq('trackCustom', nomeEvento(unidade), { unidade: unidade || '', origem: de, pagina: location.pathname });
  }
  document.addEventListener('click', function (e) {
    var gatilho = e.target.closest('[data-wa-open]'); if (gatilho) { ultimaOrigem = origem(gatilho); return; }
    var item = e.target.closest('a[data-wa-number]');
    if (item) { contato(item.getAttribute('data-wa-unit') || '', ultimaOrigem); return; }
    var direto = e.target.closest('a[href*="wa.me/"]');
    if (direto) { contato(unidadePorNumero(direto.getAttribute('href')) || direto.getAttribute('data-wa-unit') || '', origem(direto)); }
  }, true);

  /* formulários: newsletter e contato */
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !f.matches) return;
    if (f.querySelector('input[name="contact[tags]"][value*="newsletter"]') || f.matches('.footer__nl-form form, [data-newsletter]')) { window.bellaFbq('track', 'Lead', { content_name: 'newsletter' }); }
    else if (f.matches('.contact__form')) { window.bellaFbq('track', 'Lead', { content_name: 'contato' }); }
  }, true);
})();
